export default __webpack_public_path__ + "static/media/default-image.ad5db194.svg";